import { Link } from 'react-router-dom'
import { useTags } from '../hooks/useTags'

export const TagsPage = () => {
  const { data: tags, isLoading, error } = useTags()

  if (isLoading) return <p>Wird geladen…</p>
  if (error) return <p>Fehler beim Laden der Tags.</p>
  if (!tags || tags.length === 0) return <p>Keine Tags vorhanden.</p>

  return (
    <div>
      <h2>Alle Tags</h2>
      <div className="quote-tags" style={{ gap: '0.75rem', marginTop: '1rem' }}>
        {tags.map((tag) => (
          <Link key={tag.id} to={`/tags/${tag.id}`} className="tag" style={{ fontSize: '1rem' }}>
            #{tag.name}
          </Link>
        ))}
      </div>
    </div>
  )
}
